import React from 'react'

const SaveIcon14pxSvg = (props) => {
    return (
        <svg 
        {...props}
        xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M12.25 4.08333V11.0833C12.25 11.4042 12.1359 11.6789 11.9076 11.9076C11.6793 12.1362 11.4046 12.2504 11.0833 12.25H2.91667C2.59583 12.25 2.32128 12.1359 2.093 11.9076C1.86472 11.6793 1.75039 11.4046 1.75 11.0833V2.91667C1.75 2.59583 1.86433 2.32128 2.093 2.093C2.32167 1.86472 2.59622 1.75039 2.91667 1.75H9.91667L12.25 4.08333ZM11.0833 4.57917L9.42083 2.91667H2.91667V11.0833H11.0833V4.57917ZM7 10.5C7.48611 10.5 7.89931 10.3299 8.23958 9.98958C8.57986 9.64931 8.75 9.23611 8.75 8.75C8.75 8.26389 8.57986 7.85069 8.23958 7.51042C7.89931 7.17014 7.48611 7 7 7C6.51389 7 6.10069 7.17014 5.76042 7.51042C5.42014 7.85069 5.25 8.26389 5.25 8.75C5.25 9.23611 5.42014 9.64931 5.76042 9.98958C6.10069 10.3299 6.51389 10.5 7 10.5ZM3.5 5.83333H8.75V3.5H3.5V5.83333ZM2.91667 4.57917V11.0833V2.91667V4.57917Z" fill="currentColor" />
        </svg>
    )
}

export default SaveIcon14pxSvg